var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501310889,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5948,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 512h896v298.688H64z",
    fill: "#D52B1E",
    opacity: 0.75,
    "p-id": 5949
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944 512H960v298.688h-16V512zM64 512h16v298.688H64V512z",
    fill: "#D52B1E",
    "p-id": 5950
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 794.688h896v16H64z",
    fill: "#D52B1E",
    "p-id": 5951
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.368 213.312H960V512H362.368z",
    fill: "#FFFFFF",
    opacity: 0.75,
    "p-id": 5952
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M944 213.312H960V512h-16z",
    fill: "#EEEEEE",
    "p-id": 5953
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.368 213.312H960v16H362.368z",
    fill: "#EEEEEE",
    "p-id": 5954
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.312h298.688V512H64z",
    fill: "#0039A6",
    opacity: 0.75,
    "p-id": 5955
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.312h298.688v16H64z",
    fill: "#0039A6",
    "p-id": 5956
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.312h16V512H64z",
    fill: "#0039A6",
    "p-id": 5957
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.312 287.808l16.896 51.904h54.592l-44.16 32.128 16.896 51.904-44.16-32.064-44.16 32.064 16.832-51.904-44.16-32.128h54.592z",
    fill: "#FFFFFF",
    "p-id": 5958
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl);
export default __webpack_public_path__ + "static/media/cl.2e08c12c.svg";
export { ForwardRef as ReactComponent };